import React from "react";

const ResponseEnvioNegociacao = ({ show, setShow, status, fixed, text, alerts, hideButton, onClose }) => {
  const handleClose = () => {
    setShow(false);
    if (typeof onClose == "function") onClose();
  };

  return (
    <>
      {show && (
        <div className={`form-response-alert ${status} ${fixed ? "response-fixed z-[99999]" : ""}`}>
          <div className="container content flex-col !items-start">
            <span data-test-id="popup-confirmacao-renovacao">{text}</span>
            {alerts?.length > 0 && (
              <div className="mt-3 w-full">
                <span>Ocorreu um erro na tentativa de envio:</span>

                <div className="max-h-40 overflow-y-auto mt-2">
                  {alerts.map((alert) => (
                    <div key={alert} className="text-base">
                      {alert}
                    </div>
                  ))}
                </div>
              </div>
            )}
            {status !== "error" && !hideButton && (
              <button className="close-button" onClick={handleClose}>
                Fechar
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ResponseEnvioNegociacao;
